// extracted by mini-css-extract-plugin
export default {"wrapper":"gT-z","availablePromoMessagesLabel":"hT-z","promoMessageList":"iT-z","promoMessage":"jT-z","appliedPromoMessage":"kT-z","promoMessageAmount":"lT-z"};